import React from 'react'

export default props => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="10" stroke="#FC0202" stroke-width="2" />
    <path
      d="M12.176 13.184L12.496 6H10.048L10.384 13.184H12.176ZM11.28 16.832C11.984 16.832 12.576 16.24 12.576 15.552C12.576 14.848 11.984 14.256 11.28 14.256C10.576 14.256 10 14.848 10 15.552C10 16.24 10.576 16.832 11.28 16.832Z"
      fill="#FC0202"
    />
  </svg>
)
